import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Input,
  Label,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIregisterUser } from '../api/User';

import AdminUserEditUserFields from '../components/Admin/UserEdit/UserFields';
import LoginSSOButton from '../components/LoginSSOButton';
import ProcessingSpinner from '../components/ProcessingSpinner';

import {
  hideZendeskWebWidget,
  parseResponseErrors,
} from '../helpers';
import { getLogoUrl } from '../helpers/App';
import { getSetting } from '../helpers/Settings';

import Loading from '../components/Loading';

class Register extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      first_name: '',
      last_name: '',
      fields: [],
      agreed: false,
      redirect: false,
      error: null,
      errors: {},
      loading: false,
      success: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    hideZendeskWebWidget();
  }

  handleChange(e) {
    const {
      value,
      name,
      checked,
      type,
    } = e.target;
    const { state } = this;

    if (name.indexOf('userField') === 0) {
      const userFieldId = parseInt(name.replace('userField', ''));
      const userFieldIdx = state.fields.findIndex(f => f.id === userFieldId);
      if (userFieldIdx >= 0) {
        state.fields[userFieldIdx].value = value;
      } else {
        state.fields.push({
          id: userFieldId,
          value,
        });
      }
    } else if (type === 'checkbox') {
      state[e.target.name] = checked;
    } else {
      state[e.target.name] = e.target.value;
    }
    this.setState(state);
  }

  handleSubmit(e) {
    if (e) {
      e.preventDefault();
    }

    this.setState({
      loading: true,
      error: null,
    });

    if (!this.isFormValid()) {
      this.setState({ loading: false });
      return;
    }

    const {
      email,
      firstName,
      lastName,
      fields,
    } = this.state;

    APIregisterUser({
      email,
      first_name: firstName,
      last_name: lastName,
      fields,
    }).then(() => {
      this.setState({ success: true });
    }).catch((error) => {
      this.setState({
        error: Object.values(parseResponseErrors(error.response)).join(', '),
        loading: false,
      });
    });
  }

  isFormValid() {
    const {
      email,
      firstName,
      lastName,
      agreed,
      fields,
    } = this.state;
    const { intl, userFields } = this.props;

    const errors = {};

    if (!email) {
      errors.email = intl.formatMessage({ defaultMessage: 'This field is required' });
    }
    if (!firstName && !lastName) {
      errors.firstName = intl.formatMessage({ defaultMessage: 'This field is required' });
      errors.lastName = intl.formatMessage({ defaultMessage: 'This field is required' });
    }
    if (!agreed && getSetting('tos_url')) {
      errors.agreed = intl.formatMessage({ defaultMessage: 'This field is required' });
    }

    userFields
      .filter(uf => (uf.in_registration && uf.in_registration_required))
      .forEach((field) => {
        const fieldValue = fields.find(f => (f.id === field.id));
        if (!(fieldValue && fieldValue.value)) {
          errors[`userField${field.id}`] = intl.formatMessage({ defaultMessage: 'This field is required' });
        }
      });

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  }

  render() {
    const { intl, profile } = this.props;
    const {
      error,
      errors,
      redirect,
      loading,
      success,
    } = this.state;

    if (redirect || (profile && !getSetting('allow_user_registration'))) {
      return (
        <Redirect to="/" />
      );
    }

    return (
      <div className="layout layout-register">
        <div className="register-wrapper">
          <div className="register-inner">
            <div className="register-logo">
              <img src={getLogoUrl()} alt="" />
            </div>
            {!profile ? (
              <Loading />
            ) : (
              <>
                {success ? (
                  <p className="center">
                    {intl.formatMessage({
                      defaultMessage: `Thank you for your application.
                        It is in review and you will receive an email if
                        your account is approved.`,
                    })}
                  </p>
                ) : (
                  <Form
                    className="register-form"
                    onChange={this.handleChange}
                    onSubmit={this.handleSubmit}
                    noValidate
                  >
                    {getSetting('cs1') && (
                      <div className="login-saml">
                        <p>{intl.formatMessage({ defaultMessage: 'Employees, new users please log in using MyID' })}</p>
                        <a
                          href={profile.client.saml_login_url}
                          className="btn btn-outline-primary"
                          title={intl.formatMessage({ defaultMessage: 'Login with MyID' })}
                          tabIndex="-1"
                        >
                          {intl.formatMessage({ defaultMessage: 'Login with' })}{' '}
                          <img src="/images/espn/myid.svg" alt={intl.formatMessage({ defaultMessage: 'Login with MyID' })} />
                        </a>
                        <p>{intl.formatMessage({ defaultMessage: 'All other users please register below.' })}</p>
                      </div>
                    )}
                    {(!getSetting('cs1') && profile?.client?.saml_login_url) && (
                      <LoginSSOButton profile={profile} />
                    )}
                    {error && (
                      <div className="error">
                        {error}
                      </div>
                    )}
                    <p className="center">
                      <strong>{intl.formatMessage({ defaultMessage: 'Register new account' })}</strong>
                    </p>
                    <div className="groups-wrapper">
                      <FormGroup>
                        <Input
                          type="email"
                          name="email"
                          id="email"
                          placeholder={intl.formatMessage({ defaultMessage: 'Email' })}
                          invalid={Boolean(errors.email)}
                        />
                        {errors.email && (
                          <FormFeedback>{errors.email}</FormFeedback>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Input
                          type="text"
                          name="firstName"
                          id="firstName"
                          placeholder={intl.formatMessage({ defaultMessage: 'First name' })}
                          invalid={Boolean(errors.firstName)}
                        />
                        {errors.firstName && (
                          <FormFeedback>{errors.firstName}</FormFeedback>
                        )}
                      </FormGroup>
                      <FormGroup>
                        <Input
                          type="text"
                          name="lastName"
                          id="lastName"
                          placeholder={intl.formatMessage({ defaultMessage: 'Last name' })}
                          invalid={Boolean(errors.lastName)}
                        />
                        {errors.lastName && (
                          <FormFeedback>{errors.lastName}</FormFeedback>
                        )}
                      </FormGroup>
                      <AdminUserEditUserFields
                        errors={errors}
                        handleChange={this.handleChange}
                        inRegistration={true}
                      />
                      {getSetting('tos_url') && (
                        <FormGroup check>
                          <Label for="agreed" check>
                            <Input
                              type="checkbox"
                              id="agreed"
                              name="agreed"
                              className="input-check check-s form-check-input no-margin"
                              invalid={Boolean(errors.agreed)}
                            />
                            {' '}
                            {intl.formatMessage({
                              defaultMessage: 'I agree to the <link>Terms of Service</link>',
                            }, {
                              link: msg => <a href={getSetting('tos_url')} target="_blank" rel="noopener noreferrer">{msg}</a>,
                            })}
                            {errors.agreed && (
                              <FormFeedback>{errors.agreed}</FormFeedback>
                            )}
                          </Label>
                        </FormGroup>
                      )}
                      {getSetting('user_registration_links') && (
                        <div className="register-links">
                          {getSetting('user_registration_links').map(link => (
                            <p key={link.url}>
                              <a href={link.url} target="_blank" rel="noreferrer">
                                {link.text}
                              </a>
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="btn-wrapper">
                      <Button
                        type="submit"
                        disabled={loading}
                        color="primary"
                      >
                        <ProcessingSpinner show={loading} />
                        {getSetting('user_registration_button_text')}
                      </Button>
                    </div>
                  </Form>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  userFields: state.App.userFields,
});

Register.propTypes = {
  intl: PropTypes.object.isRequired,
  profile: PropTypes.object,
  userFields: PropTypes.array.isRequired,
};

Register.defaultProps = {
  profile: null,
};

export default injectIntl(connect(mapStateToProps)(Register));
